import '../styles/global.scss';
import '@wix/design-system/styles.global.css';
import '@wix/cc-user-facing-common-components/src/style.scss';

import { WixDesignSystemProvider } from '@wix/design-system';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { httpClient } from '../common/httpClient';
import { FedopsLoggerProvider } from '../common/providers/fedopsLogger';
import { HttpClientProvider } from '../common/providers/httpClient';
import { store } from '../common/store';
import { ErrorBoundary, ErrorScreen } from '../error';
import { getDesignSystemClassName } from '../util/getDesignSystemClassName';
import { fedopsLogger, renderModel } from '../util/renderModel';
import { getWidgetTheme } from '../util/theme';
import App from './App';

const { locale, messages } = renderModel.get();
const i18n = initI18n({ locale, messages });

const params = new URLSearchParams(window.location.search);
const theme = getWidgetTheme(params.get('origin'), params.get('theme'));
const themeClassName = getDesignSystemClassName(theme);

document.documentElement.classList.add(...themeClassName.split(' '));

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}
const root = createRoot(rootElement);

root.render(
  <Suspense fallback="...loading">
    <I18nextProvider i18n={i18n}>
      <FedopsLoggerProvider logger={fedopsLogger}>
        <HttpClientProvider httpClient={httpClient}>
          <Provider store={store}>
            <WixDesignSystemProvider className={themeClassName} features={{ newColorsBranding: true }}>
              <ErrorBoundary fallback={<ErrorScreen />}>
                <App />
              </ErrorBoundary>
            </WixDesignSystemProvider>
          </Provider>
        </HttpClientProvider>
      </FedopsLoggerProvider>
    </I18nextProvider>
  </Suspense>,
);
